<template>
  <b-form-group
    v-if="options && value !== undefined"
    class="custom-radio-input-gj"
  >
    <template v-slot:label>
      <div
        v-if="label"
        class="d-flex align-items-center input-radio-label"
      >
        <div class="text-secondary">
          {{ label }}
        </div>
        <span
          v-if="info"
          class="ml-1 cursor-pointer"
          @click="$emit('openInfo', info)"
        >
          <GjIcon
            size="25"
            name="Info"
          />
        </span>
        <span
          v-else
          class="preserveInfoSpace"
        />
      </div>
    </template>
    <template v-slot:default="ariaDescribedby">
      <b-form-radio-group
        v-model="value"
        :aria-describedby="ariaDescribedby"
        :name="inputName"
        class="d-flex flex-column"
        @input="input"
      >
        <b-row
          class="w-full"
          :class="{ 'd-flex flex-row-reverse': reverse }"
        >
          <b-col
            v-for="option in options"
            :key="option.value"
            :cols="cols || 12"
            :sm="smCols"
            :md="mdCols || 6"
            :lg="lgCols"
            @click="$emit('change')"
          >
            <div
              class="d-flex flex-column custom-radio-input-option-gj mb-1 px-2 py-1 rounded"
              :class="{
                'align-items-center': center,
                active: isActive(option.value),
                disabled: option.disabled,
                'variant-white': white,
                disabledItemClass: option.disabled,
              }"
              @click="!option.disabled ? input(option.value) : ''"
            >
              <img
                v-if="option.image"
                :class="`mb-1 ${imgClass}`"
                height="65px"
                :src="option.image"
                :style="option.imageWidth ? `width:${option.imageWidth}; object-fit: contain;` : 'object-fit: contain;'"
                :alt="option.text"
              >
              <b-form-radio
                v-if="!option.image"
                :value="option.value"
                :disabled="option.disabled"
                class="radio-option"
              >
                <div
                  class="option-title text-thicker"
                  :class="textSizeClass"
                >
                  {{ formatCamelCase ? formatCamelCaseString(option.text) : option.text }}
                </div>
              </b-form-radio>
              <p
                v-if="option.description"
                class="description text-secondary"
                :class="`${descriptionSizeClass} ${descriptionClass}`"
              >
                {{ option.description }}
              </p>
            </div>
          </b-col>
        </b-row>
      </b-form-radio-group>
    </template>
  </b-form-group>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'CustomInputRadio',
  props: {
    info: {
      type: Object,
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: null,
      required: true,
    },
    white: {
      type: Boolean,
      default: false,
    },
    reverse: {
      type: Boolean,
      default: false,
    },
    lgCols: {
      type: String,
      default: null,
    },
    mdCols: {
      type: String,
      default: null,
    },
    smCols: {
      type: String,
      default: null,
    },
    cols: {
      type: String,
      default: null,
    },
    textSize: {
      type: String,
      default: 'md',
    },
    descriptionSize: {
      type: String,
      default: 'sm',
    },
    descriptionClass: {
      type: String,
      default: '',
    },
    imgClass: {
      type: String,
      default: '',
    },
    disabledItemClass: {
      type: String,
      default: '',
    },
    center: {
      type: Boolean,
      default: false,
    },
    formatCamelCase: {
      type: Boolean,
      default: false,
    },
    // eslint-disable-next-line vue/require-default-prop
    value: [String, Number, Boolean],
  },
  data() {
    return {
      textSizes: ['xsm', 'sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl'],
      inputName: '',
    }
  },
  computed: {
    textSizeClass() {
      return this.getTextSizeClass(this.textSize, 'text-md')
    },
    descriptionSizeClass() {
      return this.getTextSizeClass(this.descriptionSize, 'text-sm')
    },
  },
  created() {
    this.inputName = uuidv4()
  },
  methods: {
    getTextSizeClass(val, defaultClass) {
      return this.textSizes.includes(val) ? `text-${val}` : defaultClass
    },
    isActive(value) {
      return this.value === value
    },
    input(value) {
      this.$emit('input', value)
    },
  },
}
</script>
<style lang="scss" scoped>
.variant-white {
  background-color: white;
}
</style>
